import { GET_TOKEN, GET_USER_LINKS, GET_ROLE_DETAILS, GET_MOBILE_NUMBER, UPDATE_MOBILE_NUMBER, GET_ENCRYPTPASSWORD_PHRASE, GET_ENCODE_PASSWORD } from './endpoints';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { IWGSharedService } from '../services/shared.service';

@Injectable()
export class UserService extends BaseService {

    constructor(http: HttpClient, private sharedService: IWGSharedService) {       
        super(http);
    }

    private tokenKey = !this.sharedService.getIsEmbed() ? 'accessToken' : 'accessTokenCxp';
    private userKey = !this.sharedService.getIsEmbed() ? 'IWGUserData' : 'IWGUserDataCxp';

    user = JSON.parse(localStorage.getItem(this.userKey));

    getToken(){
        return this.user.access_token;
    }

    acquireToken(username, password, roleId): Observable<any> {
        const url = GET_TOKEN;
        const data = 'grant_type=password&username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password)
        + '&scope=' + encodeURIComponent(roleId)+ '&isRequestFromClientPortal=' + true;

        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: '*/*'
            }
        };

        return this.postRequest(url, data, options).pipe(
            map((returnVal:any)=>{
                if (returnVal && returnVal.apiCallStatus) {
                    const data = returnVal.data;                    
                    this.setUserData(data);
                }
                return returnVal;
            })
        );
    }

    getRoleDetailsForEmail(username) :Observable<any> {
        const url = GET_ROLE_DETAILS + username;
        return this.getRequest(url, null);
    }

    getRoleFromClaim() :Observable<any> {
        const url = "/Account/GetRoleFromClaim";
        return this.getRequest(url, null);
    }

    getMobileNumberForEmail(username) :Observable<any> {
        const url = GET_MOBILE_NUMBER + username;
        return this.getRequest(url, null);
    };

    updateMobileNumberForEmail(mobileNumber,countryGUID): Observable<any> {
        const url = UPDATE_MOBILE_NUMBER + this.getAspNetUserID() + '&mobileNumber=' + mobileNumber + 
                    '&countryGUID=' + countryGUID;
        return this.httpClient.post<any>(url, null);
    }

    getAspNetUserID = () => {
        if (this.user) {
            return this.user.AspNetUserID;
        } else {
            return '';
        }
    }

    setUserData(data) {
        localStorage.setItem(this.tokenKey, data.access_token);
        localStorage.setItem(this.userKey, JSON.stringify(data));
        this.user = JSON.parse(localStorage.getItem(this.userKey));
    }

    setUser() {    
            this.user = JSON.parse(localStorage.getItem(this.userKey));      
    }

    getUserLinks(params: any): Observable<any> {
        const url = GET_USER_LINKS + this.makeQueryString(params);        
        return this.getRequest(url, null);
    }

    resetPassword(userName: string): Observable<any> {
        const url = '/Account/SendPasswordReset?email=' + userName;

        return this.getRequest(url, null);
    }

    getEmbedLoginToken(data: { userId: string }): any {
        const url = '/Api/Embed/EmbedLoginToken';
        const options = {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json, text/plain, */*'
            }
        };
        return this.postRequest(url, data, options);
    }
    getEmbedLoginTokenMyGuide(userId: string): Observable<any> {
        const url = '/Account/EmbedLoginToken?userId=' + userId;
        return this.getRequest(url, null);
    }
    requestAccess(accessRequest: any): Observable<any> {
        const url = '/Api/Access?' + this.makeQueryString(accessRequest);
        return this.getRequest(url, null);
    }

    clearCookie(): Observable<any> {
        const url = '/Account/ClearCookie?';
        return this.getRequest(url, null);
    }

    getEvaluateButtonDisabled = () => {
        if (this.user) {
            return this.user.NewEvaluateDisabled;
        } else {
            return '';
        }
    }

    getUser = () => {
        return this.user;
    }

    getInitials = () => {
        if (this.user) {
            return this.user.FirstName[0] + this.user.LastName[0];
        } else {
            return '';
        }
    }

    getLoggedInName = () => {
        if (this.user) {
            return this.user.FirstName+ ' ' +this.user.LastName;
        } else {
            return '';
        }
    }

    getEORDisabled = () => {
        if (this.user) {
            return this.user.EORDisabled;
        } else {
            return true;
        }
    }

    getComplianceDisabled = () => {
        if (this.user) {
            return this.user.ComplianceDisabled;
        } else {
            return true;
        }
    }

    getAORDisabled = () => {
        if (this.user) {
            return this.user.AORDisabled;
        } else {
            return true;
        }
    }

    getInvoicesDisabled = () => {
        if (this.user) {
            return this.user.InvoicesDisabled;
        } else {
            return true;
        }
    }

    getCountryGuidesDisabled = () => {
        if (this.user) {
            return this.user.CountryGuidesDisabled;
        } else {
            return true;
        }
    }


    getHomePath = () => {
        if (this.user) {
            return this.user.HomePath;
            // return '';
        } else {
            return '';
        }
    }


    getRole = () => {
        if (this.user) {
            return this.user.Role;
        } else {
            return true;
        }
    }

    getEOREstimatorAccess = () => {
        if (this.user) {
            return this.user.EOREstimatorDisabled;
        } else {
            return true;
        }
    }

    getUSEORDisabled = () => {
        if (this.user) {
            return this.user.US_EORDisabled;
        } else {
            return true;
        }
    }

    getUSComplianceDisabled = () => {
        if (this.user) {
            return this.user.US_ComplianceDisabled;
        } else {
            return true;
        }
    }

    getUSAORDisabled = () => {
        if (this.user) {
            return this.user.US_AORDisabled;
        } else {
            return true;
        }
    }

    getInternationalEORDisabled = () => {
        if (this.user) {
            return this.user.International_EORDisabled;
        } else {
            return true;
        }
    }

    getInternationalComplianceDisabled = () => {
        if (this.user) {
            return this.user.International_ComplianceDisabled;
        } else {
            return true;
        }
    }

    getInternationalAORDisabled = () => {
        if (this.user) {
            return this.user.International_AORDisabled;
        } else {
            return true;
        }
    }

    getNewQuotesDisabled = () => {
        if (this.user) {
            return this.user.NewQuotesDisabled;
        } else {
            return true;
        }
    }

    getNewEngageDisabled = () => {
        if (this.user) {
            return this.user.NewEngageDisabled;
        } else {
            return true;
        }
    }

    getIsSalesManager = () => {
        if (this.user) {
            return this.user.IsSalesManager;
        } else {
            return true;
        }
    }

    getHasSecondaryPhone = () => {
        if (this.user) {
            return this.user.HasSecondaryPhone;
        } else {
            return true;
        }
    }

    getIsSalesCEO = () => {
        if (this.user) {
            return this.user.IsSalesCEO;
        } else {
            return true;
        }
    }

    getIsSales = () => {
        if (this.user) {
            return this.user.IsSales;
        } else {
            return true;
        }
    }

    getAllowEndClients = () => {
        if (this.user) {
            return this.user.AllowEndClients;
        } else {
            return false;
        }
    }

    getAllowTeams = () => {
        if (this.user) {
            return this.user.AllowTeams;
        } else {
            return false;
        }
    }

    getDefaultEntityCountryCode = () => {
        if (this.user) {
            return this.user.DefaultEntityCountryCode;
        } else {
            return false;
        }
    }

    getDefaultEntityCurrencyCode = () => {
        if (this.user) {
            return this.user.DefaultEntityCurrencyCode;
        } else {
            return false;
        }
    }

    getNewQuoteFormatEffectiveDate = () => {
        if (this.user) {
            return this.user.NewQuoteFormatEffectiveDate;
        } else {
            return false;
        }
    }

    getShowEOREstimator = () => {
        if (this.user) {
            return this.user.ShowEOREstimator;
        } else {
            return false;
        }
    }

    getAllowedFileTypeExtensions = () => {
        if (this.user) {           
            return this.user.AllowedFileTypeExtensions;
        } else {
            return '*/*';
        }
    }

    isSignedIn = () => {
        if(this.user && this.user.access_token) {
            return true;
        }
        return false;
    }

    getNotSupportedtext = () => {
        return 'This service is not currently activated for your account. Please contact your iWorkGlobal Client Solutions representative for information about expanding your services.';
    }

    deleteToken = () => {        
        localStorage.removeItem(this.tokenKey);
        localStorage.removeItem(this.userKey);
        this.user=null;
    }

    validateSelectedFileType = (fileName, type) =>{
        if (fileName) {
            if (type && type.includes('image')) {
                return true;
            }
            var ext = fileName.split('.').pop().toLowerCase();
            var validateArray = this.getAllowedFileTypeExtensions();

            return validateArray.includes(ext);
        }
        return true;
    }   
    
    getFileUploadUnSupportErrorMessage = (fileName, isMultiple) => {
        if (isMultiple) {
            return 'Could not upload below files invalid file format:\n"' + fileName + '". \nSupported file formats: .xlsx,.xls,.doc,.docx,.txt,.pdf,rtf,.msg,.zip,.eml,images';
        } else {
            return 'Could not upload file "' + fileName + '" invalid file format. \nSupported file formats: .xlsx,.xls,.doc,.docx,.txt,.pdf,rtf,.msg,.zip,.eml,images';
        }
    }

    getMyTalentAccess = () => {
        if (this.user) {
            return this.user.MyTalentAllowed;
        } else {
            return true;
        }
    }

    getMyTalentDataConsent = () => {
        if (this.user) {
            return this.user.ShowWokerProfile;
        } else {
            return true;
        }
    }

    hasWorkerProfile = () => {
        if (this.user) {
            return this.user.HasWorkerProfile;
        } else {
            return true;
        }
    }

    getWorkerDisplayName = () => {
        var WorkerDisplayName = 'Contractor';
        //If any one of them is enabled then consider as EOR worker else consider as contractor.
        var IsEORWorker = !(this.getUSEORDisabled()) || !(this.getInternationalEORDisabled());
        if (IsEORWorker) {
            WorkerDisplayName = 'Worker';
        }
        return WorkerDisplayName;
    }

    getEndClientThreshold = () => {
        if (this.user) {
            return this.user.EndClientThreshold;
        } else {
            return '1';
        }
    }

    getSophosMaximumFileScanSize = () => {
        if (this.user) {
            return this.user.SophosMaximumFileScanSize;
        } else {
            return '16';
        }
    }
     GetEncryptPasswordPhrase = () => {
        const url = GET_ENCRYPTPASSWORD_PHRASE;
        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: '*/*'
            }
        };        
        return this.postRequest(url, null,options);
    };  
    

     EncodePassword = (password) => {        
        const url = GET_ENCODE_PASSWORD;
        const data = 'Password=' + encodeURIComponent(password);

        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: '*/*'
            }
        };

        return this.postRequest(url, data, options).pipe(
            map((returnVal:any)=>{
                // if (returnVal && returnVal.apiCallStatus) {
                //     const data = returnVal.data;
                //     console.log('userdata >> ', data);
                //     this.setUserData(data);
                // }
                return returnVal;
            })
        );
    };
 
}